window.application.register("bind", 
	class extends Stimulus.Controller {
		// <p 
        // data-controller="bind"
        // data-bind-input-id="coverageAmount"
        // data-bind-output="'₱ ' + value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')">
				
		connect(){
			this.element[this.identifier] = this;
			this.input = document.getElementById(this.data.get('inputId'));
			this.input.addEventListener('input', this.render.bind(this));
			this.render();
		}

		render(){
			var expression = this.data.get('output');
			function output(value, el){
				try{
					expression = expression.replace('`','"');
					expression = expression.replace('`','"');
					expression = expression.replace('`','"');
					expression = expression.replace('`','"');
					if(this.data.get('nanOutput')){
						var output = eval(expression);
						if(isNaN(output)){
							return this.data.get('nanOutput');
						}else{
							return output
						}
					}else{
						return eval(expression);
					}
				}catch(err){
					if(this.data.get('error-output')){
						return this.data.get('error-output');
					}else{
						return err	
					}
				}
			}
			var boundOutput = output.bind(this);
			setTimeout(()=>{
				this.element.innerHTML = boundOutput(this.input.value, this.input);
			},10)
		}

		disconnect(){
			try{this.tearDown()}catch(err){}
		}

		tearDown(){
			try{
				this.input.removeEventlistener('input', this.render.bind(this))
			}catch(err){

			}
		}
	}
)